import React from 'react';
import HexMark from './HexMark';
import styles from './SectionHead.module.css';

interface SectionHeadProps {
  eyebrow: string;
  title: string;
  titleId: string;
  lead?: React.ReactNode;
  /** トップの各節は h2（既定）。下層ページの頭では h1 にする */
  headingLevel?: 1 | 2;
  titleAriaLabel?: string;
}

const SectionHead: React.FC<SectionHeadProps> = ({
  eyebrow,
  title,
  titleId,
  lead,
  headingLevel = 2,
  titleAriaLabel,
}) => {
  const Heading = headingLevel === 1 ? 'h1' : 'h2';
  // 文字列なら段落、要素（日付ブロックなど）なら div に入れて <p> の入れ子を避ける
  const LeadTag = typeof lead === 'string' ? 'p' : 'div';

  return (
    <div className={styles.sectionHead}>
      <div className={styles.titleBlock}>
        <p className={styles.eyebrow}>
          <HexMark size={14} />
          {eyebrow}
        </p>
        <Heading
          id={titleId}
          className={styles.title}
          aria-label={titleAriaLabel}
        >
          {title}
        </Heading>
      </div>
      {lead && <LeadTag className={styles.lead}>{lead}</LeadTag>}
    </div>
  );
};

export default SectionHead;
